import { useTranslations } from 'next-intl';
import useFormatterPrice from '@/src/utils/formatter-price';

export default function AuctionDetails({
  ad,
}: {
  ad: {
    ad_auction: {
      id: number;
      time_end_extended: string;
      amount_increment: number;
    };
  };
}) {
  const t = useTranslations('AuctionDetails');
  const formatterPrice = useFormatterPrice();
  const defaultLocale = process.env.NEXT_PUBLIC_DEFAULT_LOCALE;

  return (
    <ul className='flex flex-col text-sm mx-6 bg-brand-dark px-4 py-1 rounded'>
      <li className='flex w-full justify-between border-b border-dark py-1'>
        <span>{t('timeExtension')}</span>
        <span className='font-semibold'>{t('time')}</span>
      </li>
      <li className='flex w-full justify-between py-1'>
        <span>{t('incrementAmount')}</span>
        <span className='font-semibold'>{formatterPrice(ad.ad_auction.amount_increment, defaultLocale)}</span>
      </li>      
    </ul>
  );
}
